import * as actionTypes from "./actionTypes";

export const syncViewPortWidth = () => {
  return {
    type: actionTypes.SYNC_VIEWPORT_WIDTH,
  };
};
